// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__3IiAB","upload":"Small_upload__2CJRF","imageWrap":"Small_imageWrap__kBTd1","removeBtn":"Small_removeBtn__1GQG4"};